<script setup>
import { watch, onUnmounted } from 'vue';

const props = defineProps({
  isOpen: Boolean,
  width: {
    type: Number,
    default: 440,
  },
});
const emit = defineEmits(['close']);

function closeDrawer() {
  emit('close');
}

watch(() => props.isOpen, (val) => {
  document.body.style.overflow = val ? 'hidden' : '';
});
onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<template>
  <div class="drawer-overlay" :class="{ open: isOpen }">
    <div class="drawer-backdrop" @click="closeDrawer"></div>
    <div class="drawer-panel" :style="{ maxWidth: width + 'px' }" @click.stop>
      <div class="drawer-close" @click="closeDrawer">×</div>
      <div class="drawer-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style>
.drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: none;
}

.drawer-overlay.open {
  pointer-events: auto;
}

.drawer-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s ease;
}

.drawer-overlay.open .drawer-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.drawer-panel {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.drawer-overlay.open .drawer-panel {
  transform: translateX(0%);
}

.drawer-close {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  font-size: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
}

.drawer-content {
  padding: 2rem;
  overflow-y: auto;
  height: 100%;
}
</style>
